import {
  SIGMA_LINK_BLOCKED_WORDS,
  SIGMA_LINK_CONTROL_ID_PATTERN,
  SIGMA_LINK_MAX_APPENDED_LENGTH,
  SIGMA_LINK_MAX_NAME_LENGTH,
  SIGMA_LINK_MAX_PAIRS,
  SIGMA_LINK_MAX_VALUE_LENGTH,
  SIGMA_LINK_PAGE_ID_PATTERN,
  SIGMA_NODE_ID_PARAM,
  SIGMA_PAGE_PARAM,
} from "./sigma-link-constants"

interface RawLinkParam {
  name: string
  value: string
}

function splitRawParam(rawParam: string): RawLinkParam | null {
  const separatorIndex = rawParam.indexOf("=")
  if (separatorIndex === -1) {
    return null
  }
  return { name: rawParam.slice(0, separatorIndex), value: rawParam.slice(separatorIndex + 1) }
}

function containsBlockedWord(controlId: string) {
  const squashedControlId = controlId.toLowerCase().replace(/[_-]/g, "")
  return SIGMA_LINK_BLOCKED_WORDS.some((word) => squashedControlId.includes(word))
}

function isShareableControlId(controlId: string) {
  return controlId.length <= SIGMA_LINK_MAX_NAME_LENGTH
    && SIGMA_LINK_CONTROL_ID_PATTERN.test(controlId)
    && !containsBlockedWord(controlId)
}

function isValidPageId(pageId: string) {
  return pageId.length <= SIGMA_LINK_MAX_NAME_LENGTH && SIGMA_LINK_PAGE_ID_PATTERN.test(pageId)
}

export function buildSigmaLinkParams(search: string): string {
  const queryString = search.startsWith("?") ? search.slice(1) : search
  const keptParams: RawLinkParam[] = []
  const keptControlIds = new Set<string>()
  let hasPageParam = false
  let pageId: string | null = null

  for (const rawParam of queryString.split("&")) {
    const param = splitRawParam(rawParam)
    if (!param) {
      continue
    }

    if (param.name === SIGMA_PAGE_PARAM) {
      if (!hasPageParam) {
        hasPageParam = true
        pageId = isValidPageId(param.value) ? param.value : null
      }
      continue
    }

    if (!isShareableControlId(param.name) || keptControlIds.has(param.name)) {
      continue
    }

    if (param.value.length > SIGMA_LINK_MAX_VALUE_LENGTH) {
      return ""
    }
    keptControlIds.add(param.name)
    keptParams.push(param)
  }

  if (keptParams.length > SIGMA_LINK_MAX_PAIRS) {
    return ""
  }

  const controlText = keptParams.map(({ name, value }) => `&${name}=${value}`).join("")
  const pageText = pageId === null ? "" : `&${SIGMA_NODE_ID_PARAM}=${pageId}`
  const appendedText = controlText + pageText

  return appendedText.length > SIGMA_LINK_MAX_APPENDED_LENGTH ? "" : appendedText
}
